import { apiV3 } from '@/service/v3/apiV3'
import { unravel } from '@/service/jsonApi'

const getCompany = async ({ commit }, params) => {
  commit('setFetchingCompany', true)

  const { name_key: nameKey } = params
  const response = await apiV3.companies.getCompany(nameKey)

  commit('setCompanyData', unravel(response))
  commit('setFetchingCompany', true)
}

const setFetchingCompany = (state, value) => {
  state.isFetchingCompany = value
}

const setCompanyData = (state, value) => {
  state.companyData = value
}

export default {
  state: {
    companyData: null,
    isFetchingCompany: false,
  },

  actions: {
    getCompany,
  },

  mutations: {
    setFetchingCompany,
    setCompanyData,
  },
}
